import axios from 'axios';
import ExcelJS from 'exceljs';
import { useState } from 'react';

export default function useExcel() {
  const getExcelItemText = (
    item: string | { richText: Array<{ font: any; text: string }> },
  ) => {
    if (!item) return '-';
    if (typeof item === 'object') {
      const textList = item?.richText?.map((item) => {
        return item.text;
      });
      return textList.join('');
    }

    return item;
  };

  const getTableRowCol = (
    table: Array<{ [key: string]: any }>,
    keyList: Array<string>,
  ) => {
    let rowSpan: any = keyList.reduce((pre, cur) => ({ ...pre, [cur]: 1 }), {});
    let rowPositionMap: any = keyList.reduce(
      (pre, cur) => ({ ...pre, [cur]: {} }),
      {},
    );

    function setRowSpan(key: string, item = {}) {
      if (!rowPositionMap[key]['rowSpan']) {
        rowPositionMap[key]['rowSpan'] = {};
      }
      rowPositionMap[key]['rowSpan'][key] = rowSpan[key];
      rowPositionMap[key] = item;
      rowSpan = { ...rowSpan, [key]: 1 };
    }

    table.reduce((preItem, curItem) => {
      const firstKey = keyList[0];

      if (preItem[firstKey] !== curItem[firstKey]) {
        // 将没有设置上去的值放上去
        for (const key in rowPositionMap) {
          setRowSpan(key);
        }

        // 要重置一下上一个值，不然下面还是会出现合并的问题
        preItem = {};
      }

      keyList.forEach((curKey) => {
        const curValue = curItem[curKey];
        // 跨行 - 前一个数据和后一个数据对比
        if (preItem[curKey] === curValue) {
          rowSpan[curKey] += 1;
        } else {
          // 结束了，该将数据设置到table上去。并且重置一下conSpan
          setRowSpan(curKey, curItem);
        }
      });
      return curItem;
    }, {});

    // 将没有设置上去的值放上去
    for (const key in rowPositionMap) {
      setRowSpan(key);
    }
  };
  // excel的sheet数据
  const [tabs, setTabs] = useState<Array<{ id: string; label: string }>>([]);
  const [tabValue, setTabValue] = useState<string>('');
  const [tableRecord, setTableRecord] = useState<{
    [key: string]: {
      record: Array<{ [key: string]: any }>;
      tableTitle: Array<string>;
    };
  }>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const getFileInfo = async (filePath: string) => {
    if (!filePath) return;
    try {
      setError(false);
      setLoading(true);
      const res = await axios(filePath, { responseType: 'arraybuffer' });
      return res.data;
    } catch (error) {
      setLoading(false);
      setError(true);
      return null;
    }
  };

  const readerExcel = async (filePath: string) => {
    const fileStream: any = await getFileInfo(filePath);
    if (!fileStream) return;
    // 在这里处理文件流，例如上传到服务器等
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(fileStream);
    let excelTableMap: {
      [key: string]: {
        tableTitle: Array<string>;
        record: Array<any>;
      };
    } = {};
    const tabs: Array<{ id: string; label: string }> = [];
    workbook.eachSheet((worksheet) => {
      let table: Array<{ [key: string]: any }> = [];
      let keyList: Array<string> = [];
      // 遍历工作表中具有值的所有行
      worksheet.eachRow((row, rowNumber) => {
        let values = row.values as Array<string>;
        const list = values?.slice(1, values.length);
        if (rowNumber === 1) {
          keyList = list.map(getExcelItemText);
        } else {
          const tableItem: { [key: string]: any } = {
            id: rowNumber,
          };
          keyList.forEach((key, index) => {
            const value = getExcelItemText(list[index]);
            tableItem[key] = value;
          });
          table.push(tableItem);
        }
      });
      let name = worksheet.name;
      excelTableMap[name] = {
        tableTitle: keyList,
        record: table,
      };

      tabs.push({ id: name, label: name });
      getTableRowCol(table, keyList);
    });
    setTableRecord(excelTableMap);
    setTabs(tabs);
    setTabValue(tabs[0].id);
    setLoading(false);
  };

  return {
    readerExcel,
    tabs,
    tabValue,
    setTabValue,
    tableRecord,
    loading,
    error,
  };
}
